import { Injectable } from '@angular/core'
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'
import { SettingsService, ModalHelper } from '@delon/theme'
import { AuthService } from '@shared/service/auth.service'

import { SupportWelcomeComponent } from '../../routes/support/welcome/welcome.component'

@Injectable({ providedIn: 'root' })
export class CanActivateGuard {
  constructor(
    private settingService: SettingsService,
    private modalHelper: ModalHelper,
    private router: Router,
    private authService: AuthService,
  ) {}

  whitePaths = [
    ':productionid/:boundaryid/account',
    ':ruleid/formular',
    ':ruleid/:formularid/config',
    ':accountid/method',
    ':accountid/:methodid/formula',
    ':inventoryid/action',
    ':inventoryid/launch',
    ':packageid/config',
    ':packageUserId/tenant',
    ':standardid/library',
    ':standardid/:libraryid/performance',
    ':reviewid/filling',
    'submission/:submissionid',
    ':inventoryid/scope3',
  ]

  activate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    const { url } = state
    const { routeConfig } = route
    const { path } = routeConfig as any
    const { tenantId } = this.settingService.user

    if (this.whitePaths.includes(path)) return true

    if (tenantId != -1) {
      const ownedRouters = this.authService.getOwnedRouters()

      if (ownedRouters.length == 0) {
        return this.authService.setOwnedRouters(url, () => {
          this.router.navigateByUrl('/exception/403')
        })
      } else {
        const result = !!ownedRouters.find((item: any) => item.path == url)

        if (!result) {
          this.router.navigateByUrl('/exception/403')
        }

        return result
      }
    } else {
      this.modalHelper
        .create(
          SupportWelcomeComponent,
          { record: { url } },
          {
            modalOptions: {
              nzCentered: true,
              nzWidth: 600,
            },
          },
        )
        .subscribe((res) => {
          this.router.navigateByUrl(url)
        })
      return false
    }
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    return this.activate(route, state)
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    return this.activate(route, state)
  }
}
